import React, {useContext} from "react";
import {useForm, FormProvider} from "react-hook-form";

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

import * as CustomStyles from '../styles/CustomStyles';
import * as SysUserFragment from './SysUserFragmentComponent';
import {TabPanel, a11yProps} from "../custom/CustomTabPanelComponent";
import BucketContext from "../context/BucketContext";



const TabBottomButtonBar = (props) => {
    return (
        <Grid container spacing={2} sx={CustomStyles.gridStyles}>
            <React.Fragment>
                <Grid item xs={12} container justifyContent="flex-end" alignItems="flex-end">
                    <Button variant="outlined" type="submit" sx={{ marginRight: 1 }}> {props.buttonLabel} </Button>
                </Grid>
            </React.Fragment>
        </Grid>
    );
}


function SysUserTabsRenderer(props) {
    console.log('SysUser tab renderer');

    const bucketContext = useContext(BucketContext);

    const methods = useForm({
        defaultValues: {
            lUser: props.user
        } 
    });
    const handleSubmit = methods.handleSubmit;

    const userTabIndex = bucketContext.bucket.userTabIndex != null ? bucketContext.bucket.userTabIndex : 0;

    const [tabIndex, setTabIndex] = React.useState(userTabIndex);
    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
        bucketContext.setBucketValue({ userTabIndex: newValue });
    };

    const handleSubmitGeneralData = (data) => {
        const user = {
            id: data.lUser.id,
            generalSection: data.lUser.generalSection
        }
        props.saveUser(user, data.lUser.generalSection.clientId);
    }

    return (
        <React.Fragment>

            <FormProvider {...methods} >
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={tabIndex} onChange={handleTabChange} aria-label="scrollable tabs" variant="scrollable" scrollButtons="auto">
                            <Tab label="Date Generale" {...a11yProps(0)} />
                        </Tabs>
                    </Box>

                    <TabPanel value={tabIndex} index={0}>
                        <form onSubmit={handleSubmit(handleSubmitGeneralData)} id={'generalDataTabForm'}>
                            <SysUserFragment.RenderGeneralSection />

                            <TabBottomButtonBar
                                buttonLabel='Salveaza Date Generale'
                            />
                        </form>
                    </TabPanel>
                </Box>
            </FormProvider>
        </React.Fragment>
    );
}

export default SysUserTabsRenderer